export default __webpack_public_path__ + "static/media/avatar2.2f55726f.svg";